<div class="layout-col full gap-xl">
  <app-processing-time-spec-detail
    class="flex"
    [pTimeSpec]="pTime"
    (close)="onClose($event)"
    (save)="onSave($event)"
  >
  </app-processing-time-spec-detail>
</div>
